// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvDurationConvertor } from '../Convertors/TvDurationConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { tvch } from '../Helpers/TvConsoleHelper';
import { TvSymbolsManager } from '../Managers/TvSymbolsManager';
import { TvBrokerConfigFlags } from './TvBrokerConfigFlags';
import equal from 'fast-deep-equal';
export class TvRuleValidator {
    constructor(host) {
        this.prevBrokerConfigFlags = null;
        this.prevAllowedDurations = null;
        this.host = host;
    }
    applyIfNeed() {
        const instrument = TvSymbolsManager.getCurrentInstrument();
        const account = TvAccountHelper.getCurrentAccount();
        if (instrument === null || account === null)
            return;
        const brokerConfigFlags = TvBrokerConfigFlags.getConfigFlags(instrument, account);
        if (!equal(brokerConfigFlags, this.prevBrokerConfigFlags)) {
            this.host.patchConfig(brokerConfigFlags);
            tvch.setBrokerConfigFlags(brokerConfigFlags);
        }
        this.prevBrokerConfigFlags = brokerConfigFlags;
        const allowedDurations = TvDurationConvertor.getAllowedDurationsForInstrumentAccount(instrument, account);
        if (!equal(allowedDurations, this.prevAllowedDurations)) {
            this.host.setDurations(allowedDurations);
            tvch.setAllowedDurations(allowedDurations);
        }
        this.prevAllowedDurations = allowedDurations;
    }
    isTradePosible() {
        return isValidArray(this.prevAllowedDurations);
    }
}
